export const TOOLTIP_POPPER_PROPS = { disablePortal: false };
